import { render } from "./StatsTab.vue?vue&type=template&id=06b7dd4a&scoped=true"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"

import "./StatsTab.vue?vue&type=style&index=0&id=06b7dd4a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b7dd4a"]])

export default __exports__